module.exports = "/_next/static/images/738c16a304e9bb4dc3e79b20e0ae56f3-aboutus-hiring-desktop.jpg.webp";